import * as secretCodeFormType from './secretCodeFormType'
import useSecretCodeForm from './useSecretCodeForm'
import Button from '../../../../control/button/button'
import MyTextfield from '../../../../control/textfield/textfield'
import { Grid, makeStyles, useMediaQuery, useTheme } from '@material-ui/core'
import { Form } from 'react-final-form'
import React from 'react'
import useTranslate from '../../../../i18n/useTranslate'

//View
const SecretCodeFormView = (props: secretCodeFormType.SecretCodeFormViewType) => {
    const { onClickSave, onClickClose } = props
    const translate = useTranslate()

    const theme = useTheme()
    const classes = useStyles()
    const isMobileView = useMediaQuery(theme.breakpoints.down('sm'))

    return (
        <Form onSubmit={onClickSave} initialValues={{}} keepDirtyOnReinitialize={true}>
            {(props) => {
                const { handleSubmit } = props
                return (
                    <React.Fragment>
                        {/* <Grid container spacing={2} justify={'flex-end'}> */}
                        <Grid container item spacing={2} xs={12} md={12} lg={12} justify={'flex-end'}>
                            <Grid container item xs={12} md={12} lg={12}>
                                <MyTextfield
                                    name="password"
                                    materialInputProps={{
                                        label: translate.get('LABEL.FILL_PASSWORD'),
                                        size: 'small',
                                    }}
                                    required
                                    resetButtom={true}
                                    type={'password'}
                                    maxLength={4}
                                />
                            </Grid>
                            <Grid container item xs={6} md={3} lg={3} className={classes.spacingButton}>
                                <Button
                                    variant="contained"
                                    color="inherit"
                                    fullWidth={isMobileView ? true : false}
                                    onClick={onClickClose}
                                    style={{ backgroundColor: '#FFFFFF', border: 'solid 1px #db5f8e' }}
                                >
                                    {translate.get('BUTTON.CANCEL')}
                                </Button>
                            </Grid>
                            <Grid container item xs={6} md={6} lg={6} className={classes.spacingButton}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    fullWidth={isMobileView ? true : false}
                                    onClick={handleSubmit}
                                >
                                    {translate.get('BUTTON.SAVE')}
                                </Button>
                            </Grid>
                        </Grid>
                    </React.Fragment>
                )
            }}
        </Form>
    )
}

//Controller
const SecretCodeForm = (props: secretCodeFormType.SecretCodeFormType) => {
    const secretCodeFormModel = useSecretCodeForm(props)
    return <SecretCodeFormView {...secretCodeFormModel} {...props} />
}
export default SecretCodeForm

const useStyles = makeStyles((theme) => ({
    spacingButton: {
        marginBottom: '10px',
    },
}))
